export default __webpack_public_path__ + "static/fireside-9b512b0f04e433b25e5389764ce770b5.png";